import {CtModelRouteData} from "@ctsolution/ct-framework";

export const ContactFeeRouteData = (): CtModelRouteData => CtModelRouteData
  .create()
  .setController("contactfee");
